import { render, staticRenderFns } from "./BaseButtonTinyWhite.vue?vue&type=template&id=380c90e8&scoped=true&"
import script from "./BaseButtonTinyWhite.vue?vue&type=script&lang=js&"
export * from "./BaseButtonTinyWhite.vue?vue&type=script&lang=js&"
import style0 from "./BaseButtonTinyWhite.vue?vue&type=style&index=0&id=380c90e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "380c90e8",
  null
  
)

export default component.exports